<template>
  <main>
    <div class="row">
      <div class="col-md-12 list-school">
        <TopTemplate>
          <template v-slot:right-element>
            <div class="d-flex buttons-wrapper">
              <a
                @click="showModalFile()"
                class="btn button btn-outline-primary importe"
              >
                <i class="icon-file-01" />
                {{ $t('button.importBDD') }}
              </a>
              <router-link
                :to="{ name: 'add_school' }"
                class="btn button btn-primary"
                :disabled="loading"
              >
                <i class="icon-Add" />
                {{ $t('button.addSchool') }}
              </router-link>
            </div>
          </template>
          <template v-slot:left-element>
            <h3>Écoles ({{ total }})</h3>
          </template>
        </TopTemplate>
        <b-modal
          ref="bddModal"
          v-model="showModal"
          id="modal-prevent-closing"
          size="lg"
          centered
          title="Importer BDD d'une école"
          hide-footer
        >
        <form @submit.prevent="onSubmitSchool">
          <div class="form-message">
            <label for="otherDoc" class="file-input" @change="onFileChange">
              <img
                class="icon-import"
                src="../../../assets/icons/VectorMsg.svg"
              />
              <input
                id="otherDoc"
                type="file"
                class="d-none"
                accept=".xlsx, .xls, .xlsm, .xlsb"
                tabindex="-1"
              />
              <span v-if="namedoc" class="justify name-doc">
                {{ namedoc }}
              </span>
              <span v-else class="justify">
                {{ $t("info.downloadDocs") }}
              </span>
            </label>
           
          </div>
          <label class="indice_format">{{ $t("info.formatFile") }}</label>
            <span v-if="errorDocFormat" class="indice errorSizeDoc">{{
              $t("error.errorTailleMsg")
            }}</span>
          <hr/>
          <div class="col-12 buttons btn-action-modal">
          <button  type="submit"  class="btn button btn-primary right-btn" :disabled="isSubmit"><i class="icon-Check"></i>{{ $t('button.save') }}</button>
          
          <button
            type="button"
            @click="showModalFile()"
            class="btn btn-outline-primary button left-btn"
          >
            <i class="icon-Add"></i>{{$t('button.annuler') }}
          </button>
        </div>
      </form>
        </b-modal>
       
      </div>
    </div>
    <b-alert v-if="errorContenu" show variant="danger">{{ $t('error.errorFormat') }}</b-alert>
    <div
      class="search-date-wrapper search-filter-wrapper"
      :class="showFil === false ? 'borderNan' : ''"
    >
      <div class="search searchStudent">
        <input
          type="text"
          placeholder="Recherche"
          name="search"
          v-model="params.q"
          @input="searchSchool()"
        />
        <img
          src="../../../assets/icons/search-icon.svg"
          class="icon-search"
          alt="search"
        />
      </div>
      <div class="date-wrapper filter-wrapper" @click="showFilter()">
        <span>{{ $t("barFiltre.filtre") }}</span>
      </div>
    </div>
    <div v-if="showFil" class="row container-select container-filter">
      <div v-if="selectedGouv || selectedDeleg" class="col-md-12">
        <div class="reset_student" @click="resetFilter()">
          <i class="icon-reset" />
          {{ $t("barFiltre.renitialiser") }}
        </div>
      </div>
      <div class="col-md-6 select-wrapper">
        <span class="title-select">{{ $t("barFiltre.gouvernorat") }}</span>
        <v-select
          v-model="selectedGouv"
          :options="governorates"
          :searchable="true"
          label="governorate"
          :reduce="(option) => option"
          @update:modelValue="ChangeGouvernorat($event)"
        >
          <template #no-options="{ search, searching, loading }">{{
            $t("info.noResult")
          }}</template>
        </v-select>
      </div>
      <div class="col-md-6 select-wrapper">
        <span class="title-select">{{ $t("barFiltre.delegation") }}</span>
        <v-select
          v-model="selectedDeleg"
          :options="delegations"
          :searchable="true"
          label="delegation"
          :reduce="(option) => option"
          @update:modelValue="ChangeDeleg($event)"
        >
          <template #no-options="{ search, searching, loading }">{{
            $t("info.noResult")
          }}</template>
        </v-select>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid empty-message">
      <div class="col-md-12">
        <div v-if="!loading && schools.length == 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearchSchool") }}</p>
          </div>
        </div>
      </div>
    </div>
   
    <div class="table" v-if="!loading && schools.length > 0">
      <div class>
        <div class="row">
          <div class="col-md-12">
            <div class="table__wrapper">
              <table>
                <thead>
                  <tr>
                    <th
                      width="20em"
                      class="message eleve"
                      @click="sortB('name')"
                    >
                      {{ $t("school.name") }}
                      <div class="icon-wrapper">
                        <i
                          class="ri-arrow-up-s-line"
                          :class="[specTri('name', true)]"
                          @click="sort(false, 'name')"
                        />
                        <i
                          class="ri-arrow-down-s-line"
                          :class="[specTri('name', false)]"
                          @click="sort(true, 'name')"
                        />
                      </div>
                    </th>
                    <th width="20em" @click="sortB('delegation_id')">
                      {{ $t("school.gouvernorat") }}
                      <div class="icon-wrapper">
                        <i
                          class="ri-arrow-up-s-line"
                          :class="[specTri('delegation_id', true)]"
                          @click="sort(false, 'delegation_id')"
                        />
                        <i
                          class="ri-arrow-down-s-line"
                          :class="[specTri('delegation_id', false)]"
                          @click="sort(true, 'delegation_id')"
                        />
                      </div>
                      <!-- <div>
                          <i @click="sort(false,'first_name')" class="ri-arrow-up-s-line" />
                          <i @click="sort(true,'first_name')" class="ri-arrow-down-s-line" />
                        </div> -->
                    </th>
                    <th
                      width="20em"
                      class="date"
                      @click="sortB('governorate_id')"
                    >
                      {{ $t("school.delegation") }}
                      <div class="icon-wrapper">
                        <i
                          class="ri-arrow-up-s-line"
                          :class="[specTri('governorate_id', true)]"
                          @click="sort(false, 'governorate_id')"
                        />
                        <i
                          class="ri-arrow-down-s-line"
                          :class="[specTri('governorate_id', false)]"
                          @click="sort(true, 'governorate_id')"
                        />
                      </div>
                    </th>
                    <th width="20em" class="action act-end">
                      {{ $t("common.actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ecole in schools" :key="ecole.id">
                    <td>
                      <router-link
                        style="color: black; font-weight: 600"
                        :to="{
                          name: 'school_detail',
                          params: { id: ecole.id },
                        }"
                      >
                        <span v-if="ecole.name"> {{ ecole.name }} </span>&nbsp;
                      </router-link>
                    </td>
                    <td>
                      <span v-if="ecole.governorate_name">
                        {{ ecole.governorate_name }}
                      </span>
                      <!-- <span v-if="student.class">
                          {{ student.class.name
                          }}
                        </span> -->
                    </td>

                    <td>
                      <!-- <span v-if="student.birthday">
                          {{ $filters.date(student.birthday)
                          }}
                        </span> -->
                      <span v-if="ecole.delegation_name">
                        {{ ecole.delegation_name }}
                      </span>
                    </td>
                    <td>
                      <router-link
                        :to="{
                          name: 'school_detail',
                          params: { id: ecole.id },
                        }"
                        class
                      >
                        <i class="icon-eyes">
                          <span class="tooltiptext">{{
                            $t("button.tooltip.details")
                          }}</span>
                        </i>
                      </router-link>

                      <router-link
                        :to="{ name: 'EditSchool', params: { id: ecole.id } }"
                        class
                      >
                        <i class="icon-edit-02">
                          <span class="tooltiptext">{{
                            $t("button.tooltip.update")
                          }}</span>
                        </i>
                      </router-link>
                      <i
                        class="icon-trash"
                        @click.prevent="deleteSchool(ecole.id)"
                      >
                        <span class="tooltiptext">{{
                          $t("button.tooltip.delete")
                        }}</span>
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div
                v-if="total > params.limit"
                class="table__wrapper__pagination-wrapper"
              >
                <!-- <div class="button-delete">
                                      <button
                                          @click.prevent="deleteSelected"
                                          class="btn btn-outline-primary button"
                                          :disabled="
                                              selected.length == 0 ? true : false
                                          "
                                      >
                                          <i class="icon-trash"></i>
                                          Supprimer
                                      </button>
                  </div>-->

                <div class="pagination">
                  <pagination :dataSet="pagination" @goToPage="getResults" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../../components/toptemplate/TopTemplate.vue";
import pagination from "../../../components/navigation/Pagination";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import SchoolService from "../../../services/school.service";
export default {
  name: "EcoleList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
    Datepicker,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/0${month}/${year}`;
      }
      if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `0${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };

    return {
      format,
    };
  },
  data() {
    return {
      loading: false,
      pagination: {},
      total: 0,
      classes: [],
      levels: [],
      datea: null,
      readInput: true,
      showFil: false,
      showModal: false,
      params: {
        q: "",
        limit: 7,
        page: 1,
        sort: "created_at",
        order: false,
        class_type_id: [],
        class_school_id: [],
        birthday: null,
        datede: null,
      },
      selectedLevel: null,
      selectedClass: null,
      schools: [],
      selected: [],
      delegations: [],
      governorates: [],
      selectedGouv: null,
      selectedDeleg: null,
      namedoc: null,
      file: null,
      extension:null,
      errorDocFormat: false,
      errorContenu:false,
      isSubmit:false
    };
  },
  computed: {
    selectAll: {
      get: function () {
        return this.schools
          ? this.selected.length == this.schools.length
          : false;
      },
      set: function (value) {
        let selected = [];

        if (value) {
          this.schools.forEach(function (school) {
            selected.push(school.id);
          });
        }

        this.selected = selected;
      },
    },
  },
  mounted() {
    this.ListSchool();
    this.getGouvernorat();
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
      this.namedoc = this.file.name;
      this.extension = file.name.split('.').pop();
      let reader = new FileReader();

      reader.onloadend = (file) => {
        const files = e.target.files[0];
      this.checkFilesFormat(extension);
      };
      reader.readAsDataURL(file);
    },
    checkFilesFormat: _.throttle(function (extension) {
      if (extension != 'xlsx' || extension != 'xls' || extension != 'xlsm' || extension != 'xlsb') {
        this.errorDocFormat = false;
      }
    }, 300),
    showModalFile() {
      this.showModal = !this.showModal;
    },
    onSubmitSchool(){
        let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("file", this.file);
        SchoolService.import(formData).then(
          this.isSubmit = true,
          (response) => {
            this.errorContenu = false;
             this.getResults()
             this.isSubmit = false
          },
          (error) => {
            this.errorContenu = true;
            console.error(error);
          }
        )
        .finally(() => {
          this.$nextTick(() => {
            this.showModal = false;
            this.namedoc = null;
            this.getResults();

          });
        });
     },
    resetFilter() {
      this.selectedGouv = null;
      this.selectedDeleg = null;
      this.getResults();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListSchool();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListSchool();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    deleteSchool(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const index = this.schools.findIndex((items) => items.id === id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSchool"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              this.$t("common.schoolDeleted"),
              "",
              "success"
            );
            this.schools.splice(index, 1);
            SchoolService.delete(id);
            this.getResults();
          }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    ChangeGouvernorat(e) {
      if (e != null) {
        this.selectedGouv = e;
        this.delegations = _.orderBy(e.delegation, "delegation");
      } else {
        this.selectedGouv = null;
        this.selectedDeleg = null;
      }
      this.ListSchool();
    },
    getDelegations(params) {
      this.loading = true;
      SchoolService.getDelegations({
        params: {
          governorat_id: params,
        },
      })
        .then((response) => {
          this.selectedClass = null;
          this.delegations = _.orderBy(
            response.data.data[0].delegation,
            "delegation"
          );
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    ChangeDeleg(e) {
      if (e != null) {
        this.selectedDeleg = e;
      }
      this.ListSchool();
    },
    handleInput() {
      this.readInput = false;
      if (this.params.datede != null) {
        this.params.datede = this.dateTime(this.params.datede);
      }
      this.getResults();
    },
    getGouvernorat() {
      this.loading = true;
      SchoolService.getGouvernorat({
        params: {
          governorat_id: this.selectedGouv,
        },
      })
        .then((response) => {
          this.selectedClass = null;
          this.delegations = _.orderBy(response.data.delegations, "delegation");
          this.governorates = _.orderBy(
            response.data.governorates,
            "governorate"
          );

          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    ListSchool() {
      this.loading = true;
      SchoolService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_school_id,
          class_type_id: this.params.class_type_id,
          // birthday: this.params.birthday
          birthday: this.params.datede,
          governorat_id: this.selectedGouv?.id,
          delegation_id: this.selectedDeleg?.id,
        },
      })
        .then((response) => {
          this.schools = response.data.data;
          this.total = response.data.meta.total;

          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      SchoolService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_school_id,
          class_type_id: this.params.class_type_id,
          //  birthday: this.params.birthday
          birthday: this.params.datede,
        },
      })
        .then((response) => {
          this.schools = response.data.data;
          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    searchSchool: _.debounce(function () {
      if (
        this.params.q.toString().length > 1 ||
        !this.params.q.toString().length
      ) {
        this.params.hasfilter = true;
        this.ListSchool();
      }
    }, 200),
  },
};
</script>
<style>
span.justify.name-doc {
  color: #585858;
}
</style>